import Config from '../config';

export default {
    install: function (Vue) {
        const dmv = {
            env:           Config,
            notifyError:   (message) => Vue.notify({text: message, type: 'error'}),
            notifySuccess: (message) => Vue.notify({text: message, type: 'success'})
        }
        Vue.$dmv = dmv;
        Vue.prototype.$dmv = dmv;
    }
}


